import React from 'react'
import { Link } from 'react-router-dom'

import { Helmet } from 'react-helmet'

import NavbarInteractive from '../components/navbar-interactive'
import Footer from '../components/footer'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container1">
      <Helmet>
        <title>Als je niets bent - marjangerrits.nl</title>
        <meta
          name="description"
          content="Dubbelroman over de Tweede Wereldoorlog, de twee kanten van een oorlog."
        />
        <meta
          property="og:title"
          content="Als je niets bent - marjangerrits.nl"
        />
        <meta
          property="og:description"
          content="Dubbelroman over de Tweede Wereldoorlog, de twee kanten van een oorlog."
        />
      </Helmet>
      <div className="home-top-container">
        <NavbarInteractive rootClassName="navbar-interactiveroot-class-name25"></NavbarInteractive>
      </div>
      <div id="main-section" className="home-main">
        <div className="home-banner">
          <div className="home-container2">

            <img
              alt="image"
              src="/cover%20dubbelroman%20web%20kleine%20rand-1200w.png"
              className="home-thumbnail-boek"
            />
            <span className="home-text10">
              <span className="home-text11">Als je niets bent</span>
              <br className="home-text12"></br>
              <span className="home-text13">Twee kanten van een oorlog</span>
              <br></br>
              <span>ISBN: 978-90-835269-0-4</span>
              <br className="home-text16"></br>
              <span>Aantal pagina’s: 292</span>
              <br className="home-text18"></br>
              <span>Prijs: € 22,50</span>
              <br className="home-text20"></br>
              <br className="Content"></br>
            </span>
          </div>
          <Link to="/contact" className="home-navlink1">
            <div className="home-bestelknop1">
              <h3 className="home-bestel1">Bestel het boek hier</h3>
            </div>
          </Link>
          <div className="home-uitleg-dubbelroman">
            <h2 className="home-dubbelroman1">
              <span className="home-text22">
                Deze op waarheid gebaseerde oorlogsroman kun je omdraaien en dan
                lees je over de ander kant van de oorlog.
              </span>
              <br className="home-text23"></br>
            </h2>
            <h2 className="home-dubbelroman2 Dikgedrukt_tekst">
              Dit boek is een dubbelroman, dat betekent dat je hem kunt
              omdraaien en van beide kanten kunt lezen. Hij heeft dus twee
              voorkanten, zoals je op de foto ziet. De achterflap is vervangen
              door twee binnenflappen, elk met een samenvatting van de inhoud
              van die kant.
            </h2>
          </div>
          <div className="home-boek-blok">
            <h3 className="home-als-je-niets-bent BlogTitel">
              <span className="home-text24">Als je niets bent</span>
              <br></br>
            </h3>
            <h3 className="home-twee-kanten-van-een-oorlog Subtitel">
              Twee kanten van een oorlog
            </h3>
            <span className="home-omschrijving-boek">
              <span className="home-text26">Linker voorkant</span>
              <br className="home-text27"></br>
              <span className="home-text28">
                Wat gebeurt er met een jongeman wanneer oorlog alles van hem
                afpakt: zijn vrijheid, zijn veiligheid, zijn toekomst?
              </span>
              <br></br>
              <span>
                Nederland is bezet en Ab wordt opgeroepen voor dwangarbeid in
                Duitsland. Onderduiken lijkt de enige optie, maar dreiging en
                verraad zijn nooit ver weg. In 1944 staat de Gestapo voor de
                deur. Wat volgt, is een nachtmerrie van gevangenschap,
                dwangarbeid en ontbering in de concentratiekampen Amersfoort,
                Buchenwald en Langenstein-Zwieberge. Elke dag is een strijd
                tegen honger, kou en onderdrukking. Maar hij geeft niet op. Met
                elke stap, elke ademhaling, blijft hij vechten voor één doel:
                terugkeer naar huis.
              </span>
              <br></br>
              <br></br>
              <span className="home-text33">
                Aan de andere kant van het boek (rechter voorkant)
              </span>
              <br className="home-text34"></br>
              <span className="home-text35">
                Hoe vorm je je eigen identiteit wanneer je opgroeit in een
                wereld waar ideologie alles bepaalt?
              </span>
              <br></br>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>
                Voor Albert, een bakkerszoon uit Bremen, lijkt de toekomst
                helder uitgestippeld. Hij groeit op in het
                nationaalsocialistische Duitsland, wordt lid van het Jungvolk en
                later van de Hitlerjugend, en leert gehoorzamen zonder vragen te
                stellen. Als jonge soldaat in de Wehrmacht wordt Albert ingezet
                in Frankrijk. Terwijl zijn geboortestad gebombardeerd wordt en
                zijn broer vermist raakt, wordt hij zelf gevangengenomen.
                Tijdens zijn gevangenschap worstelt hij met zorgen over het
                thuisfront en het verlies van oude zekerheden. Wat betekent
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>thuis</span>
              <span> nog als alles wat je kende niet meer bestaat?</span>
              <br></br>
              <br className="Content"></br>
              <span>
                In dit indringende boek beschrijft Marjan Gerrits het leven van
                twee jongemannen die in dezelfde oorlog werden meegezogen. Aan
                de ene kant het verhaal van haar vader, die vocht om te
                overleven in de gruwelen van de kampen. Aan de andere kant het
                verhaal van haar Duitse schoonvader, gevangen in een systeem dat
                hem tot gehoorzaamheid dwong. Twee levens, gescheiden door de
                oorlog, maar verbonden door dezelfde strijd: mens blijven in
                onmenselijke omstandigheden.
              </span>
              <br></br>
              <br className="Content"></br>
              <span className="home-text46">
                Een gelaagd portret van overleven, veerkracht en de
                kwetsbaarheid van vrijheid, gezien door twee unieke
                perspectieven die samen een completer beeld geven van wat oorlog
                met mensen doet.
              </span>
              <br className="Content"></br>
            </span>
          </div>
          <Link to="/contact" className="home-navlink2">
            <div className="home-bestelknop2">
              <h3 className="home-bestel2">Bestel het boek hier</h3>
            </div>
          </Link>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default Home
